import React, { useState, useContext, useLayoutEffect } from 'react';
import { MdDelete, MdEdit } from 'react-icons/md';

import * as S from './styles';
import { color } from 'styles/pallete';
import AddBtn from 'components/AddBtn';
import Modal from 'components/Modal';
import SimpleInput from 'components/SimpleInput';
import SelectInput from 'components/SelectInput';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import {
	optionsWeightFontText,
	optionsRedirectType
} from 'utils/optionsInputs';
import { DataFormProps } from 'components/FormDynamicPageSelected/Forms/InputsTitleWithRedirect/index';
import DynamicPageContext from 'context/DynamicPage';
import SystemNotifyContext from 'context/SystemNotifyContext';
import { returListOptionsDynamicPage, canSaveLink } from './functions';

import InputColor from 'components/InputColor';

const initialLink = {
	name: '',
	redirect_type: '',
	redirect_value: '',
	weight: null,
	element_id: '',
	page_group_id: '',
	facets: '',
	color: '#000'
};

interface LinkFormTitleWithRedirectProps {
	isShow: boolean;
	dataForm: DataFormProps;
	setDataForm: React.Dispatch<React.SetStateAction<DataFormProps>>;
}

export default function LinkFormTitleWithRedirect({
	isShow,
	dataForm,
	setDataForm
}: LinkFormTitleWithRedirectProps) {
	const [isOpenForm, setIsOpenForm] = useState(false);
	const { handleNotify } = useContext(SystemNotifyContext);
	const { dynamicPagesList } = useContext(DynamicPageContext);

	const [optionsDynamicScreen, setOptionsDynamicScreen] = useState<
		SelectInputItemProps[]
	>([]);

	function findOptionOnListById(value: string, list: SelectInputItemProps[]) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	function findOptionOnListByOption(
		value: string,
		list: SelectInputItemProps[]
	) {
		const itemsList = list.filter((item) => item.option === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	function returnNameRedirectByIdDynamicScreen(id: string) {
		const item = optionsDynamicScreen.filter((item) => item.id === id);
		return item.length > 0 ? item[0].option : 'Não encontrado';
	}

	function save() {
		const canSave = canSaveLink(dataForm, handleNotify);

		if (canSave) {
			setIsOpenForm(false);
		}
	}

	//preciso zera o facets se o tipo de redirect mudar
	useLayoutEffect(() => {
		if (dataForm.link.redirect_type !== 'query') {
			setDataForm((obj) => ({ ...obj, link: { ...obj.link, facets: '' } }));
		}
	}, [dataForm.link.redirect_type]);

	//preciso zera as imagens se o type default
	useLayoutEffect(() => {
		if (dataForm.type === 'default') {
			setDataForm((obj) => ({
				...obj,
				link: { ...obj.link, file_id: '', urlImg: '' }
			}));
		}
	}, [dataForm.type]);

	//cria lista de opções de pagínas dinamicas em um estado para evitar reenderização
	useLayoutEffect(() => {
		setOptionsDynamicScreen(returListOptionsDynamicPage(dynamicPagesList));
	}, []);

	return (
		<S.container $isShow={isShow}>
			<AddBtn
				anyFunction={() => {
					setIsOpenForm(true);
				}}
				text={dataForm.link.name === '' ? 'Adicionar link' : 'Editar link'}
			/>

			{dataForm.link.redirect_value === '' ? (
				<S.noLink>
					<p>Não há link cadastrado</p>
				</S.noLink>
			) : (
				<S.banner>
					<S.content>
						<p>
							<b>Tipo de redirecionamento: a</b> {dataForm.link.redirect_type}
						</p>
						<p>
							<b>Valor do redirecionamento</b> :
							{dataForm.link.redirect_type === 'app_screen'
								? returnNameRedirectByIdDynamicScreen(
										dataForm.link.redirect_value
									)
								: dataForm.link.redirect_value}
						</p>

						<S.colorInfo $color={dataForm.link.color}>
							<b>Cor do texto:</b>
							<div />
						</S.colorInfo>
					</S.content>

					<S.actions>
						<MdDelete
							onClick={() => {
								setDataForm((obj: any) => ({ ...obj, link: initialLink }));
							}}
							color={color.system.error}
						/>
						<MdEdit
							onClick={() => {
								setIsOpenForm(true);
							}}
							color={color.interface.darkgray3}
						/>
					</S.actions>
				</S.banner>
			)}

			<Modal
				isOpenProps={isOpenForm}
				setIsOpenModal={() => {
					setIsOpenForm(false);
					setDataForm((obj: any) => ({ ...obj, link: initialLink }));
				}}
				title={'Adicionar Link'}
				buttonClose={false}
			>
				<S.inputs>
					<S.twoInputs>
						<SimpleInput
							label="Título"
							initialValue={dataForm.link.name}
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									link: { ...obj.link, name: value }
								}));
							}}
						/>

						<SelectInput
							list={optionsWeightFontText}
							getValue={(value: SelectInputItemProps | '') => {
								setDataForm((obj) => ({
									...obj,
									link: {
										...obj.link,
										weight: value === '' ? value : value?.option
									}
								}));
							}}
							initialValue={
								dataForm.link.weight === ''
									? ''
									: findOptionOnListByOption(
											dataForm.link.weight || '',
											optionsWeightFontText
										)
							}
							label="Peso da fonte"
						/>

						<SelectInput
							list={optionsRedirectType}
							getValue={(value: SelectInputItemProps | '') => {
								setDataForm((obj) => ({
									...obj,
									link: {
										...obj.link,
										redirect_type: value === '' ? value : (value?.id as string)
									}
								}));
							}}
							initialValue={
								dataForm.link.redirect_type === ''
									? optionsRedirectType[0]
									: findOptionOnListById(
											dataForm.link.redirect_type || '',
											optionsRedirectType
										)
							}
							label="Redirecionamento"
						/>

						{(dataForm.link.redirect_type === '' ||
							dataForm.link.redirect_type === 'product' ||
							dataForm.link.redirect_type === 'url' ||
							dataForm.link.redirect_type === 'webview' ||
							dataForm.link.redirect_type === 'query' ||
							dataForm.link.redirect_type === 'screen_app') && (
							<SimpleInput
								label="Valor Redirecionamento *"
								initialValue={dataForm.link.redirect_value}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										link: { ...obj.link, redirect_value: value }
									}));
								}}
							/>
						)}

						{dataForm.link.redirect_type === 'app_screen' && (
							<SelectInput
								list={optionsDynamicScreen}
								getValue={(value: SelectInputItemProps | '') => {
									setDataForm((obj) => ({
										...obj,
										link: {
											...obj.link,
											redirect_value:
												value === '' ? value : (value?.id as string)
										}
									}));
								}}
								initialValue={
									dataForm.link.redirect_value === ''
										? ''
										: findOptionOnListById(
												dataForm.link.redirect_value || '',
												optionsDynamicScreen
											)
								}
								label="Valor Redirecionamento *"
							/>
						)}
					</S.twoInputs>

					<InputColor
						rgbOrExadecimal={false}
						label="Cor do texto"
						value={dataForm.link.color || '#000'}
						setValue={(value: string) => {
							setDataForm((obj) => ({
								...obj,
								link: { ...obj.link, color: value }
							}));
						}}
					/>

					{dataForm.link.redirect_type === 'query' && (
						<SimpleInput
							label="Facetas"
							initialValue={dataForm.link.facets}
							getValue={(value: string) => {
								setDataForm((obj) => ({
									...obj,
									link: { ...obj.link, facets: value }
								}));
							}}
						/>
					)}

					<S.containerBtns>
						<S.cancel
							onClick={() => {
								setIsOpenForm(false);
							}}
						>
							Cancelar
						</S.cancel>
						<S.save onClick={save}>Salvar</S.save>
					</S.containerBtns>
				</S.inputs>
			</Modal>
		</S.container>
	);
}
